import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
var ContextMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenu, _React$Component);
  var _super = _createSuper(ContextMenu);
  function ContextMenu(props) {
    var _this;
    _classCallCheck(this, ContextMenu);
    _this = _super.call(this, props);
    _this.setMenuPosition = function () {
      var menuHeight = _this.menu.offsetHeight;
      // get height of context menu when the menu is drawing completed in this page
      if (menuHeight === 0) {
        requestAnimationFrame(_this.setMenuPosition);
      }
      var top = 0;
      if (_this.position.top + menuHeight > document.body.clientHeight) {
        top = document.body.clientHeight - menuHeight - 5;
      } else {
        top = _this.position.top;
      }
      var left = _this.position.left + 3;
      _this.setState({
        contextStyle: {
          top: top,
          left: left,
          zIndex: '1071',
          display: 'block'
        }
      });
    };
    _this.state = {
      contextStyle: {}
    };
    _this.tableUtils = props.tableUtils;
    return _this;
  }
  _createClass(ContextMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.position = this.props.contextMenuPosition;
      this.setMenuPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.menu = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        role: 'menu',
        style: this.state.contextStyle,
        ref: function ref(_ref) {
          return _this2.menu = _ref;
        },
        className: 'seafile-contextmenu dropdown-menu'
      }, /*#__PURE__*/React.createElement("button", {
        onMouseDown: function onMouseDown(event) {
          return _this2.tableUtils.insertRow('before');
        },
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Insert_Row_Before')), /*#__PURE__*/React.createElement("button", {
        onMouseDown: function onMouseDown(event) {
          return _this2.tableUtils.insertRow('after');
        },
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Insert_Row_After')), /*#__PURE__*/React.createElement("button", {
        onMouseDown: function onMouseDown(event) {
          return _this2.tableUtils.insertColumn('before');
        },
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Insert_Column_Before')), /*#__PURE__*/React.createElement("button", {
        onMouseDown: function onMouseDown(event) {
          return _this2.tableUtils.insertColumn('after');
        },
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Insert_Column_After')), /*#__PURE__*/React.createElement("div", {
        className: 'seafile-divider dropdown-divider'
      }), /*#__PURE__*/React.createElement("button", {
        onMouseDown: this.tableUtils.removeRow,
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Remove_Row')), /*#__PURE__*/React.createElement("button", {
        onMouseDown: this.tableUtils.removeColumn,
        className: 'seafile-contextmenu-item dropdown-item'
      }, this.props.t('Remove_Column')));
    }
  }]);
  return ContextMenu;
}(React.Component);
export default withTranslation('seafile-editor')(ContextMenu);